module.exports = __webpack_public_path__ + "static/java-e4d127e5104267bcf44f2f65f17a794e.svg";